import { IEnquiryType } from '@/interfaces/contactUs';

const contactUsConstants = {
  CONTACT_US: 'Contact Us',
  DESCRIPTION:
    'These ToS may be updated, amended, modified or revised by us from time to time. Each such updation or modification to the ToS will be communicated to you via email, through the Website or any other medium. Your continued use of the PW Skills Services after any such changes shall constitute your consent to such changes. We encourage you to refer to these ToS from time to time to ensure that you are aware of any additions, revisions, amendments or modifications that we may have made.',
  SUBMIT: 'Submit',
  FULL_NAME: 'Full Name *',
  EMAIL: 'Email Address *',
  ORGANISATION_NAME: 'Organisation Name *',
  ENTER_MOBILE_NUMBER: 'Enter your Mobile Number *',
  YOUR_MESSAGE: 'Your message *',
  SUCCESS: 'Enquiry Sent',
  ERROR: `Something's Wrong`,
  NAME_ERROR: 'Please enter your name',
  MOBILE_NUMBER_ERROR: 'Please enter valid Mobile Number',
  ORGANISATION_ERROR: 'Please enter valid Organisation Name',
  EMAIL_ERROR: 'Please enter email',
  MESSAGE_ERROR: 'Please enter message',
};

export const enquiryTypes: IEnquiryType[] = [
  { _id: '1', name: 'Course Enquiry' },
  { _id: '2', name: 'Corporate Enquiry' },
];

export default contactUsConstants;
